import LoginFlowPresenter from "@adapters/features/LoginFlow/Presenters/LoginFlow";
export default (useCases, actions) => {
    return {
        login: new LoginFlowPresenter(useCases.login, actions.login),
    };
};
